import { fuego } from '@nandorojo/swr-firestore';
import { IChat } from '@typings/chat/chat.interface';
import { CollectionPath, SubColPath } from '@typings/collections.enum';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

type Props = {
  data: IChat;
  docId: string; // chatList docID
};

export async function addChat({ data, docId }: Props) {
  const ref = fuego.db.collection(
    `${CollectionPath.CHAT}/${docId}/${SubColPath.CHATLIST}`,
  );
  const parentRef = fuego.db.collection(`${CollectionPath.CHAT}`);

  const chatId = await ref
    .add({
      ...data,
      createdAt: firebase.firestore.Timestamp.now(),
    })
    .then((res) => res.id)
    .catch((err) => console.log(err.message));

  // 부모채팅룸의 edit 시간을 최신으로 업데이트
  parentRef.doc(docId).set({ editedAt: new Date() }, { merge: true });

  // 보내는 유저 모두에게 unRead가 하나 쌓여야 함.
  // 단, 보내는 본인 제외
  if (data.receiverIds)
    Promise.allSettled(
      // data.receiverIds = participants (부모 chatroom doc에 있음)
      data.receiverIds.map(async (receiverId, i) => {
        // data.senterId === currentUserUId 보내는 본인 제외
        if (receiverId === data.senderId) return;

        const userRef = fuego.db.collection(
          `${CollectionPath.USERS}/${receiverId}/${CollectionPath.CHAT}`,
        );

        // 🔧 기존 unRead 배열에 새 chatId 추가 (덮어쓰기 방지)
        return await userRef
          .doc(docId)
          .update({
            unRead: firebase.firestore.FieldValue.arrayUnion(chatId),
            latestDoc: { ...data, chatRoomId: docId }
          })
          .catch(async (err) => {
            // 문서가 존재하지 않으면 새로 생성
            if (err.code === 'not-found') {
              return await userRef
                .doc(docId)
                .set({
                  unRead: [chatId],
                  latestDoc: { ...data, chatRoomId: docId }
                })
                .catch((err) => console.log('Set error:', err.message));
            }
            console.log('Update error:', err.message);
          });
      }),
    );
}

export async function readChatCheck({ currentUserUid, docId, chatId = null }) {
  const userRef = fuego.db.collection(
    `${CollectionPath.USERS}/${currentUserUid}/${CollectionPath.CHAT}`,
  );

  // 🔧 특정 chatId만 제거하거나 전체 초기화
  if (chatId) {
    // 특정 메시지만 읽음 처리
    return userRef
      .doc(docId)
      .update({
        unRead: firebase.firestore.FieldValue.arrayRemove(chatId)
      })
      .catch((err) => console.log('Remove chatId error:', err.message));
  } else {
    // 전체 읽음 처리 (채팅룸 진입 시)
    return userRef
      .doc(docId)
      .set({ unRead: [], latestDoc: null }, { merge: true })
      .catch((err) => console.log('Clear all error:', err.message));
  }
}
